'use strict';
import fuse from '../../../_libs/redux-fusion';
import {projectTasksCtrlConfig} from '../../../tasks/router-project-tasks';
import {FORM_REQUIREMENT_COLLECTION} from '../../domain/config';
import {updateProjectFormReqResponseReduxRequest} from '../../redux/forms/updateProjectFormReqResponse';
import {updateProjectFormRequirementRequestModal} from '../../redux/forms/updateProjectFormRequirement';
import {RequirementViewFormContainer} from './RequirementViewFormContainer';
import {RequirementViewFormView} from './RequirementViewFormView';


const StreamedComponent = RequirementViewFormContainer({
  collection: FORM_REQUIREMENT_COLLECTION,
  taskListState: projectTasksCtrlConfig.taskListState,
  taskDetailsState: projectTasksCtrlConfig.taskDetailsState,
  updateResponseReduxRequest: updateProjectFormReqResponseReduxRequest,
  updateReduxRequestModal: updateProjectFormRequirementRequestModal,
});

export const ProjectRequirementViewFormContainer = fuse(StreamedComponent)(RequirementViewFormView);



// WEBPACK FOOTER //
// ./src/js/requirements/components/RequirementViewForm/ProjectRequirementViewFormContainer.js